const RESCHEDULE_EMAILS = ["max@pageport.co", "max@pageport.com", "hhayesbema10@gmail.com"]
const RESCHEDULE_DOMAINS = ["example.com"]
const INTERNAL_EMAIL_DOMAINS = ["slant.app", "pageport.co", "pageport.com"]

export function isInternalUser(email: string | undefined): boolean {
  if (!email) return false
  const domain = email.toLowerCase().split("@").at(-1)
  return INTERNAL_EMAIL_DOMAINS.includes(domain ?? "")
}

export function canRescheduleEvents(email: string | undefined): boolean {
  if (!email) return false
  if (RESCHEDULE_EMAILS.includes(email)) return true
  return RESCHEDULE_DOMAINS.some((domain) => email.endsWith(`@${domain}`))
}
